import axios from "axios";
import { API_URL } from "../../../config.tsx";

/**
 * Запрос брендов автомобилей
 * @returns {Promise<any>}
 */
export const carBrandsRequest = () => {
    return axios.get(`${API_URL}/car_brands`, { withCredentials: true })
        .then(response => response.data);
};
